import { Children, cloneElement, ReactElement, ReactNode } from "react";
import styles from "./tree-node-renderer.module.scss";

// @nosferatu500/react-sortable-tree's package.json "exports" only allows importing "."
// so its tree-node.d.ts TreeRendererProps type isn't importable here.
interface TreeRendererProps {
  children: ReactNode;
  listIndex: number;
  swapFrom?: number | null;
  swapLength?: number | null;
  swapDepth?: number | null;
  scaffoldBlockPxWidth: number;
  lowerSiblingCounts: number[];
  connectDropTarget: (node: ReactElement) => any;
  isOver: boolean;
  draggedNode?: any;
  canDrop?: boolean | null;
  treeIndex: number;
  treeId: string;
  getPrevRow: () => any;
  node: any;
  path: (string | number)[];
  rowDirection?: string;
  [key: string]: any;
}

const TreeNodeRenderer = (props: TreeRendererProps) => {
  const {
    children,
    listIndex,
    swapFrom = null,
    swapLength = null,
    swapDepth = null,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    scaffoldBlockPxWidth,
    lowerSiblingCounts,
    connectDropTarget,
    isOver,
    draggedNode = null,
    canDrop = null,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    treeIndex,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    treeId, // Delete from otherProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPrevRow, // Delete from otherProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    node, // Delete from otherProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    path, // Delete from otherProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    rowDirection,
    ...otherProps
  } = props;

  return connectDropTarget(
    <div {...otherProps} className={styles.node}>
      {Children.map(children, (child) =>
        cloneElement(child as ReactElement<any>, {
          isOver,
          canDrop,
          draggedNode,
          lowerSiblingCounts,
          listIndex,
          swapFrom,
          swapLength,
          swapDepth,
        }),
      )}
    </div>,
  );
};

export default TreeNodeRenderer;
